import { useState } from 'react'
import './NFTCard.css'

export default function NFTCard({ nft }) {
	const [flipped, setFlipped] = useState(false)

	const handleCopy = text => {
		navigator.clipboard.writeText(text)
		alert('Copied to clipboard ✅')
	}

	return (
		<div
			className={`nft-flip-card ${flipped ? 'flipped' : ''}`}
			onClick={() => setFlipped(!flipped)}
		>
			<div className='nft-flip-inner'>
				{/* FRONT SIDE */}
				<div className='nft-flip-front'>
					<img src={nft.image} alt={nft.name} className='nft-image' />
					<p className='nft-title'>{nft.name}</p>
				</div>

				{/* BACK SIDE */}
				<div className='nft-flip-back'>
					<p className='nft-title'>{nft.name}</p>
					<div className='nft-info'>
						<div className='nft-row'>
							<span className='nft-label'>Owner:</span>
							<span
								className='nft-copy'
								onClick={e => {
									e.stopPropagation()
									handleCopy(nft.owner)
								}}
							>
								{nft.owner}
							</span>
						</div>

						<div className='nft-row'>
							<span className='nft-label'>NFT Addr:</span>
							<span
								className='nft-copy'
								onClick={e => {
									e.stopPropagation()
									handleCopy(nft.address)
								}}
							>
								{nft.address}
							</span>
						</div>

						<div className='nft-row'>
							<span className='nft-label'>Collection:</span>
							{nft.collectionName === 'Fucken Me Collection' ? (
								<a
									href='https://testnet.getgems.io/collection/kQC2OsGzZk8OEgXCTJJA0w-wHcaX9BdixRTQfgIXi7ungPli'
									target='_blank'
									rel='noopener noreferrer'
									style={{
										color: '#ff7722',
										textDecoration: 'underline',
										marginLeft: '4px',
									}}
								>
									{nft.collectionName}
								</a>
							) : (
								<span style={{ marginLeft: '4px' }}>
									{nft.collectionName || 'Art Gallery'}
								</span>
							)}
						</div>

						{nft.description && (
							<div className='nft-row'>
								<span className='nft-label'>Desc:</span>
								<span>{nft.description}</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
